module.exports = __webpack_public_path__ + "static/media/Sunflower-Village-Rules-and-Regulations.58ab7f5e.pdf";